import { useCloudComputingPower } from 'store'
import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/top-credit/favicon.ico'
import bannerRight from '../../assets/image/top-credit/home/banner-right.png'
import downloadBg from '../../assets/image/top-credit/home/support-platform/download-bg.png'
import logo from '../../assets/image/top-credit/logo.svg'
import simpleLogo from '../../assets/image/top-credit/simple-logo.svg'
import { BaseConfig } from '../common-config'

/** 合规相关 */
import arkham from '../../assets/image/top-credit/legal-compliance/arkham.png'
import blocksec from '../../assets/image/top-credit/legal-compliance/blocksec.png'
import chainanalysis from '../../assets/image/top-credit/legal-compliance/chainalysis.png'
import cloudFlare from '../../assets/image/top-credit/legal-compliance/cloud-flare.png'
import elliptic from '../../assets/image/top-credit/legal-compliance/elliptic.png'
import googleCloud from '../../assets/image/top-credit/legal-compliance/google-cloud.png'
import jamf from '../../assets/image/top-credit/legal-compliance/jamf.png'
import nansen from '../../assets/image/top-credit/legal-compliance/nansen.png'
import slowmist from '../../assets/image/top-credit/legal-compliance/slowmist.png'
import sumsub from '../../assets/image/top-credit/legal-compliance/sumsub.png'

/** 合约相关 --- end */

/** 海报相关 --- start */
import cnPoster1 from '../../assets/image/top-credit/poster/zh_CN/1.png'
import cnPoster2 from '../../assets/image/top-credit/poster/zh_CN/2.png'
import cnPoster3 from '../../assets/image/top-credit/poster/zh_CN/3.png'
import cnBanner from '../../assets/image/top-credit/poster/zh_CN/banner.png'

import enPoster1 from '../../assets/image/top-credit/poster/en/1.png'
import enPoster2 from '../../assets/image/top-credit/poster/en/2.png'
import enPoster3 from '../../assets/image/top-credit/poster/en/3.png'
import enBanner from '../../assets/image/top-credit/poster/en/banner.png'
import { debitCard } from './common'
/** 海报相关 --- end */

const primary = '#C63547'

const lightPrimary = '#E81B40'

const secondaryPrimary = '#E81B40'

const tertiaryPrimary = '#8B1A1A'

/** 汇信配置 */
export const TopeCreditConfig: PlatformConfig = merge(lodashDeepClone(BaseConfig) as PlatformConfig, {
  themeType: 'light',
  logo: logo,
  simpleLogo,
  footerLogo: logo,
  platformName: import.meta.env.VITE_PLATFORM_NAME,
  contentWidth: `1200px`,
  loginShowDownload: true,
  colors: {
    lightPrimary: lightPrimary,
    hoverPrimary: '#151519',

    zero: '#C2C7D0',
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    error: '#FC495C',
    warning: '#FF8A00',
    success: '#00D391',
    link: '#4B5BE7',
    text: {
      base: '#151519',
      reverse: '#fff',
      primaryAlt: '#151519',
      secondary: '#75777A',
      tertiary: '#A0A3A7',
      quaternary: '#75777A',
      hover: '#151519',
    },
    bg: {
      base: '#FFFFFF',
      reverse: '#151519',
      secondary: '#FFFFFF',
      hover: '#EAECEF4C',
      tertiary: '#f7f7f9',
      icon: {
        primary: '#151519',
        secondary: '#75777A',
        trigger: '#E3E3E3',
        quaternary: '#8E9196',
      },
      button: {
        base: primary,
        primary: primary,
        primaryTextColor: '#fff',
        disabledTextColor: '#fff',
        aux: '#F6F7F9',
        disabled: '#C2C7D0',
      },
      tag: {
        base: '#F3F4F6',
      },
      form: {
        base: '#F7F7F9',
        input: '#F7F7F9',
        modal: '#F1F3F6',
        card: '#ffffff',
      },
      mainPage: {
        base: '#FFFFFF',
        card: '#F5F5F7',
        actionBar: '#f3f4f6',
      },
      modal: {
        base: '#FFFFFF',
        card: '#ffffff',
        shadow: 'rgba(224, 227, 237, 0.9)',
      },
    },
    tip: '#F6F7F9',
    cardBorder: '#EAECEF',
    divider: '#EAECEF',
    borderSelected: '#74777B',
    sliderMenu: '#F4F5F6',
  },

  ico,
  header: {
    color: '#151519',
    // boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    background: '#fff',
    aColor: '#151519',
    regBtnBgColor: '#FFFF38', // 注册按钮背景
    regTextColor: '#10151F', // 注册按钮文字颜色
    downloadTextColor: '#151519',
    activeColor: '#151519',
  },

  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },
  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  compliance: {
    cooperativeInstitutions: {
      list: [
        { logo: chainanalysis, width: 170 },
        { logo: slowmist, width: 154 },
        { logo: nansen, width: 140 },
        { logo: elliptic, width: 130 },
        { logo: jamf, width: 94 },
        { logo: cloudFlare, width: 178 },
        { logo: arkham, width: 140 },
        { logo: sumsub, width: 150 },
        { logo: googleCloud, width: 165 },
        { logo: blocksec, width: 160 },
      ],
    },
  },
  debitCard: debitCard,
  cloud: {
    colors: {
      bg: {
        card: {
          primary: '#F3F4F6',
          fontColor: '#151519',
        },
      },
    },
  },
  posterConf: {
    zh_CN: {
      poster1: cnPoster1,
      poster2: cnPoster2,
      poster3: cnPoster3,
      banner: cnBanner,
    },
    en: {
      poster1: enPoster1,
      poster2: enPoster2,
      poster3: enPoster3,
      banner: enBanner,
    },
  },
})
